import type { StateCreator } from "zustand";
import { create as _create } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

const resetters: (() => void)[] = [];

/**
 * 一括でリセット可能なzustandストアを作成します。
 * ログアウト時にストアをリセットする必要がある場合に使用します。
 * devtoolsとimmerを内包しているので、Devtoolからのデバッグが可能です。
 *
 * @param createState ストアの作成関数
 * @returns ストア
 * @deprecated ReactContext の活用で、コンポーネントのライフサイクルと同時にリセットすることができる https://zustand.docs.pmnd.rs/guides/initialize-state-with-props
 * -> zustand-context-pattern.ts でユーティリティを提供
 */
export const create = <TState>(
  createState: StateCreator<
    TState,
    [["zustand/devtools", never], ["zustand/immer", never]]
  >,
) => {
  const slice = _create(devtools(immer(createState)));

  const initialState = slice.getState();

  /**
   * 公式的にも型アサーションしろってか？
   * https://zustand.docs.pmnd.rs/migrations/migrating-to-v5#handling-dynamic-replace-flag
   */
  const args = [initialState, true] as Parameters<typeof slice.setState>;
  resetters.push(() => {
    slice.setState(...args);
  });

  return slice;
};

export const resetAllStores = () => {
  for (const resetter of resetters) {
    resetter();
  }
};
